import * as React from "react";
import { useGetOne, useTranslate } from "react-admin";
import { Typography, Stack, Box, Chip } from "@mui/material";
import AssociateRapToPod from "../remoteAccessPoint/associateRapToPod";
import DisAssociateRapToPod from "../remoteAccessPoint/disassociateRapToPod";

const RapSerialNumberField = ({ podId }) => {
    const translate = useTranslate();

    const { data: pod, isLoading, error } = useGetOne("pods", { id: podId }, { enabled: !!podId });

    if (!podId) return null;
    if (isLoading) return null; // or a small spinner/text
    if (error) return null;     // or show error

    const serial = pod.rapSerialNumber;
    const ssid = pod.rapSSID;

    return (
        <Stack
            direction="row"
            sx={{ width: "100%", mt: 1 }}
            alignItems="center"
            justifyContent="space-between"
        >

            <Chip
                label={
                    <span>
                        <span style={{
                            fontWeight: 600,           // NOT bold
                            color: 'rgba(0,0,0,0.7)', // #000000DE
                        }}>
                            RAP Serial Number:{' '}
                        </span>
                        {serial || '-'}
                    </span>
                }
                sx={{
                    height: 30,
                    fontSize: "0.8rem",
                    px: 1,
                    borderRadius: "17px",
                    mb: 1,
                }}
            />

            {serial ?
                <Chip
                    label={
                        <span>
                            <span
                                style={{
                                    fontWeight: 600,           // NOT bold
                                    color: 'rgba(0,0,0,0.7)', // #000000DE
                                }}
                            >
                                RAP SSID:
                            </span>{' '}
                            {ssid || '-'}
                        </span>
                    }
                    sx={{
                        height: 30,
                        fontSize: '0.8rem',
                        px: 1,
                        borderRadius: '17px',
                        mb: 1,
                    }}
                />

                : ''}


            {serial ? (
                <DisAssociateRapToPod pod={podId} showTitle='yes' />
            ) : (
                <AssociateRapToPod pod={podId} />
            )}
        </Stack>

    );
};

export default RapSerialNumberField;
